export default "__VITE_ASSET__BjVgDuWc__"